var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-5",attrs:{"loading":_vm.loading}},[_c('template',{slot:"progress"},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1),_c('v-card-title',[_vm._v("Plan Uptake")]),_c('v-card-text',[(!_vm.loading)?_c('pie-chart',{ref:"chart",attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }